/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../common/autocomplete/autocomplete.component.ngfactory';
import * as i4 from '../../../../../src/app/common/autocomplete/autocomplete.component';
import * as i5 from '../../../../../src/app/components/ingresocausa/datos-demanda.component';
import * as i6 from '../../../../../src/app/services/usuario.service';
import * as i7 from '../../../../../src/app/services/common.service';
var styles_DatosDemandaComponent = [];
export var RenderType_DatosDemandaComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_DatosDemandaComponent, data: {} });
function View_DatosDemandaComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class',
                'horizontal-collapse'], ['style', 'margin-top:20px;']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'well']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            ', '\n            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-secondary']], [[8, 'hidden', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickOK() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Continuar'])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.MsgTipos;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.verAceptar;
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_DatosDemandaComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.desc;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_DatosDemandaComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-xs-12 col-sm-8  isa_error msg-error']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-times-circle']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n        '])), (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ErrorMsg;
        _ck(_v, 5, 0, currVal_0);
    });
}
export function View_DatosDemandaComponent_0(_l) {
    return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { autocomplete: 0 }), (_l()(), i0.ɵeld(0, null, null, 132, 'div', [['class', 'panel-body height-panel-nuevacausa']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [['class',
                'wizard-title']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Datos de la Demanda'])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DatosDemandaComponent_1)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 10, 'div', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 3, 'label', [['class', 'required']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Concepto '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'a', [['style', 'color: #e32']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['*'])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'autocomplete', [], null, [['document', 'click']], function (_v, en, $event) {
            var ad = true;
            if (('document:click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 23).handleClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, i3.View_AutocompleteComponent_0, i3.RenderType_AutocompleteComponent)),
        i0.ɵdid(49152, [[1, 4]], 0, i4.AutocompleteComponent, [i0.ElementRef], { config: [0,
                'config'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])),
        (_l()(), i0.ɵeld(0, null, null, 30, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 27, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 24, 'div', [['class', 'fg-line alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 21, 'div', [['class', 'select required colorlbx']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Caracter de la Causa '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 15, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'ngModelChange'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 42).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 42).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onChangeSelectTipo($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_3 = ((_co.causa.nivel = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, [' '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(),
            i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        (_l()(), i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DatosDemandaComponent_2)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])),
        (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 12, 'div', [['class', 'fg-line alto-combos required']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Monto del Proceso'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control input-sm bginputs t-upper'],
            ['id', 'montoProceso'], ['name', 'Monto'], ['step', '0.01'], ['type', 'number']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'keyup'], [null, 'keypress'], [null, 'change'], [null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 72)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 72).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 72)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 72)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (i0.ɵnov(_v, 73).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (i0.ɵnov(_v, 73).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (i0.ɵnov(_v, 73).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('keyup' === en)) {
                var pd_7 = (_co._keyUp($event) !== false);
                ad = (pd_7 && ad);
            }
            if (('keypress' === en)) {
                var pd_8 = (_co._keyPress($event) !== false);
                ad = (pd_8 && ad);
            }
            if (('change' === en)) {
                _co.setTwoNumberDecimal();
                var pd_9 = (_co.onChangeSelectTipo($event.target.value) !== false);
                ad = (pd_9 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_10 = ((_co.causa.monto = $event) !== false);
                ad = (pd_10 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i1.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i1.DefaultValueAccessor, i1.ɵbc]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(),
            i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DatosDemandaComponent_3)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-7 col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [['class', 'ts-label reset-margin alto-combos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Solicito con Habilitación'])), (_l()(), i0.ɵted(null, ['\n      '])),
        (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'col-xs-5 col-sm-6 padBottom2 reset-margin alto-combos']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵeld(0, null, null, 10, 'label', [['class', 'switch']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n              '])), (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['type', 'checkbox']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 98).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 98).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.causa.habil = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.CheckboxControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.CheckboxControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n              '])), (_l()(), i0.ɵeld(0, null, null, 0, 'span', [['class', 'slider round']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(),
            i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class', 'col-sm-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵeld(0, null, null, 13, 'div', [['class', 'fg-line margin-bottom-obs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Observaciones'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 7, 'textarea', [['class', 'form-control input-sm bginputs t-upper'],
            ['cols', '50'], ['maxlength', '300'], ['name', 'obser'], ['rows', '3'], ['style',
                'border:solid 1px #ababab;']], [[1, 'maxlength', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 122)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 122).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 122)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 122)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.causa.observaciones = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(540672, null, 0, i1.MaxLengthValidator, [], { maxlength: [0, 'maxlength'] }, null), i0.ɵprd(1024, null, i1.NG_VALIDATORS, function (p0_0) {
            return [p0_0];
        }, [i1.MaxLengthValidator]), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8,
                null], [2, i1.NG_VALIDATORS], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(),
            i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵted(null, ['\n\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.visibleMsg;
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = _co.autocompleteConfigAPISource;
        _ck(_v, 23, 0, currVal_1);
        var currVal_9 = _co.causa.nivel;
        _ck(_v, 44, 0, currVal_9);
        var currVal_10 = '0';
        _ck(_v, 50, 0, currVal_10);
        var currVal_11 = '0';
        _ck(_v, 51, 0, currVal_11);
        var currVal_12 = _co.caracterList;
        _ck(_v, 55, 0, currVal_12);
        var currVal_20 = 'Monto';
        var currVal_21 = _co.causa.monto;
        _ck(_v, 75, 0, currVal_20, currVal_21);
        var currVal_22 = _co.ErrorMessageIsVisible;
        _ck(_v, 83, 0, currVal_22);
        var currVal_30 = _co.causa.habil;
        _ck(_v, 100, 0, currVal_30);
        var currVal_39 = '300';
        _ck(_v, 123, 0, currVal_39);
        var currVal_40 = 'obser';
        var currVal_41 = _co.causa.observaciones;
        _ck(_v, 126, 0, currVal_40, currVal_41);
    }, function (_ck, _v) {
        var currVal_2 = i0.ɵnov(_v, 46).ngClassUntouched;
        var currVal_3 = i0.ɵnov(_v, 46).ngClassTouched;
        var currVal_4 = i0.ɵnov(_v, 46).ngClassPristine;
        var currVal_5 = i0.ɵnov(_v, 46).ngClassDirty;
        var currVal_6 = i0.ɵnov(_v, 46).ngClassValid;
        var currVal_7 = i0.ɵnov(_v, 46).ngClassInvalid;
        var currVal_8 = i0.ɵnov(_v, 46).ngClassPending;
        _ck(_v, 41, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_13 = i0.ɵnov(_v, 77).ngClassUntouched;
        var currVal_14 = i0.ɵnov(_v, 77).ngClassTouched;
        var currVal_15 = i0.ɵnov(_v, 77).ngClassPristine;
        var currVal_16 = i0.ɵnov(_v, 77).ngClassDirty;
        var currVal_17 = i0.ɵnov(_v, 77).ngClassValid;
        var currVal_18 = i0.ɵnov(_v, 77).ngClassInvalid;
        var currVal_19 = i0.ɵnov(_v, 77).ngClassPending;
        _ck(_v, 71, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19);
        var currVal_23 = i0.ɵnov(_v, 102).ngClassUntouched;
        var currVal_24 = i0.ɵnov(_v, 102).ngClassTouched;
        var currVal_25 = i0.ɵnov(_v, 102).ngClassPristine;
        var currVal_26 = i0.ɵnov(_v, 102).ngClassDirty;
        var currVal_27 = i0.ɵnov(_v, 102).ngClassValid;
        var currVal_28 = i0.ɵnov(_v, 102).ngClassInvalid;
        var currVal_29 = i0.ɵnov(_v, 102).ngClassPending;
        _ck(_v, 97, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29);
        var currVal_31 = (i0.ɵnov(_v, 123).maxlength ? i0.ɵnov(_v, 123).maxlength : null);
        var currVal_32 = i0.ɵnov(_v, 128).ngClassUntouched;
        var currVal_33 = i0.ɵnov(_v, 128).ngClassTouched;
        var currVal_34 = i0.ɵnov(_v, 128).ngClassPristine;
        var currVal_35 = i0.ɵnov(_v, 128).ngClassDirty;
        var currVal_36 = i0.ɵnov(_v, 128).ngClassValid;
        var currVal_37 = i0.ɵnov(_v, 128).ngClassInvalid;
        var currVal_38 = i0.ɵnov(_v, 128).ngClassPending;
        _ck(_v, 121, 0, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38);
    });
}
export function View_DatosDemandaComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'datos-demanda', [], null, null, null, View_DatosDemandaComponent_0, RenderType_DatosDemandaComponent)), i0.ɵdid(114688, null, 0, i5.DatosDemandaComponent, [i6.UsuarioService, i7.CommonService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var DatosDemandaComponentNgFactory = i0.ɵccf('datos-demanda', i5.DatosDemandaComponent, View_DatosDemandaComponent_Host_0, { tex_cod: 'tex_cod',
    fuero: 'fuero', tipo: 'tipo', inst: 'inst', cir: 'cir', cir_descr: 'cir_descr', tex_cod_conexo: 'tex_cod_conexo',
    conexo: 'conexo', organismo: 'organismo' }, { onComplete: 'onComplete' }, []);
//# sourceMappingURL=datos-demanda.component.ngfactory.js.map